import { create } from 'zustand';
import { Role } from 'src/types/api/ListRole';

interface RolesState {
  selectedRole: Role | null;
  selectedRoleId: string | null;
  
  // Actions
  setSelectedRole: (role: Role | null) => void;
  setSelectedRoleId: (id: string | null) => void;
  
  // Reset all selections
  resetSelections: () => void;
}

export const useRolesStore = create<RolesState>((set) => ({
  selectedRole: null,
  selectedRoleId: null,
  
  setSelectedRole: (role) => set({ selectedRole: role }),
  setSelectedRoleId: (id) => set({ selectedRoleId: id }),
  
  resetSelections: () => set({ selectedRole: null, selectedRoleId: null }),
}));
